export default "__VITE_ASSET__Rpx5PHXq__"